import { DefaultService } from '@/services/DefaultService';

export default class AssTurnoFeriadoService extends DefaultService {

	constructor(http, router, env) {
		super(http, router, env);
	}

    find(id){
        return this._http.get(`${this._env}/promotor/shifts/${id}.json`, this._headers).then(res => {
            return res.body.content;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllByIdTurno (idturno, situacao, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/sales/turnoferiado/getall/${idturno}.json?situacao=${situacao}&order=${order}&column=${column}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(turnoferiado) {
        return this._http.post(`${this._env}/sales/turnoferiado/updatesituacao`, turnoferiado, this._headers).then(res => {
          return res.body;
        }, err => {
          this.verifyError(err);
          throw err;
        });
    }
    save(turno) {
        return this._http.post(`${this._env}/sales/turnoferiado`, turno, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
    saveBulk(turnosFeriados) {
        return this._http.post(`${this._env}/sales/turnoferiado/insertbulk`, turnosFeriados, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    update(turnoferiado) {
        return this._http.post(`${this._env}/sales/turnoferiado`, turnoferiado, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }
}